import { useState } from "react";
import { LinkPageDto } from "../../domain/LinkPageDto";
import { Button, Modal } from "antd";
import LinkPagesApi from "../../api/LinkPagesApi";

export interface DeletePageModalProps {
  page: LinkPageDto | null;
  isVisible: boolean;
  onClose: (removed: boolean) => void;
}

export function DeletePageModal({
  page,
  isVisible,
  onClose,
}: DeletePageModalProps) {
  const [removing, setRemoving] = useState(false);

  function remove() {
    setRemoving(true);
    LinkPagesApi.removeLandingPage(page?.id!)
      .then(() => {
        onClose(true);
        setRemoving(false);
      })
      .catch(() => {
        setRemoving(false);
      });
  }

  return (
    <Modal
      className={"create-folder-modal clean"}
      visible={isVisible}
      onCancel={() => onClose(false)}
    >
      <header>
        <h2>Are you sure?</h2>
      </header>

      <p>This Link Page will be disabled and removed from your library.</p>

      <footer>
        <Button size={"large"} onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={remove}
          loading={removing}
        >
          Ok
        </Button>
      </footer>
    </Modal>
  );
}
